export default __webpack_public_path__ + "static/media/rose-yellow.01ecfcdb.svg";